var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"field-label"},[_c('input',_vm._b({attrs:{"type":"radio"},domProps:{"checked":_vm.shouldBeChecked,"value":_vm.value},on:{"change":_vm.updateInput}},'input',_vm.$attrs,false)),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }